export default __webpack_public_path__ + "static/media/shipping-stripes.5fd10ddd.svg";